export class ComuneDTO {
	istat: string;
	nomeComune: string;
	provincia: string;
	regione: string;
	cop: string;
	prefisso: string;
	abitanti: number;
	cat: number;
	ibanComune: string;
	pIva: string;
	listaCap: Array<string>;
}